// key เก็บสถานะเปิด/ปิดแจ้งเตือนบนเดสก์ท็อป (per-browser เหมือนฝั่งเสียง)
const STORAGE_KEY = 'gochat_desktop_notification_enabled'

class DesktopNotification {
  // เบราว์เซอร์รองรับ Notification API ไหม
  isSupported() {
    return typeof window !== 'undefined' && 'Notification' in window
  }

  // สถานะสิทธิ์ปัจจุบัน: 'granted' | 'denied' | 'default' | 'unsupported'
  permission() {
    return this.isSupported() ? Notification.permission : 'unsupported'
  }

  // user เปิดใช้ไว้ใน localStorage ไหม (default ปิด)
  isEnabled() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) === true
    } catch (e) {
      return false
    }
  }

  // เปิดใช้งาน — ขอ permission ตอนนี้ (ต้องเรียกจาก user gesture) แล้ว return permission ที่ได้
  // เปิดสำเร็จเฉพาะเมื่อ permission === 'granted'
  enable() {
    var self = this
    if (!this.isSupported()) {
      return Promise.resolve('unsupported')
    }
    var current = Notification.permission
    // ถ้ายังไม่เคยตัดสินใจ → ขอสิทธิ์ (เบราว์เซอร์เด้งถามแอดมิน)
    if (current === 'default') {
      return new Promise(function (resolve) {
        var handled = false
        var done = function (perm) {
          if (handled) return
          handled = true
          self._set(perm === 'granted')
          resolve(perm)
        }
        try {
          // เบราว์เซอร์ใหม่คืน Promise, เบราว์เซอร์เก่าใช้ callback — รองรับทั้งสองแบบ
          var maybe = Notification.requestPermission(function (perm) { done(perm) })
          if (maybe && typeof maybe.then === 'function') {
            maybe.then(done).catch(function () { done(Notification.permission) })
          }
        } catch (e) {
          done(Notification.permission)
        }
      })
    }
    // granted อยู่แล้ว → เปิดได้เลย / denied → เปิดไม่ได้ (ต้องไปปลดบล็อกเองในเบราว์เซอร์)
    this._set(current === 'granted')
    return Promise.resolve(current)
  }

  // ปิดใช้งาน (แค่เคลียร์ flag ฝั่งเรา — ไม่ยุ่งกับ permission ของเบราว์เซอร์)
  disable() {
    this._set(false)
  }

  _set(value) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
    } catch (e) {
      // เขียน localStorage ไม่ได้ (private mode/บล็อก) — เงียบไว้ ไม่ให้ throw ทะลุ
    }
  }

  // ยิงแจ้งเตือนบนเดสก์ท็อป — เงื่อนไข "ลูกค้า + tab hidden" ให้ caller คุมมาก่อน
  // ที่นี่ป้องกันซ้ำ: เปิดใช้ + รองรับ + permission granted เท่านั้น
  // tag: กันซ้อนต่อลูกค้า (ข้อความใหม่จากคนเดิม = แทนที่อันเก่า), onClick: โฟกัสหน้าต่างกลับมา
  notify(title, body, tag, onClick) {
    if (!this.isEnabled()) return
    if (!this.isSupported() || Notification.permission !== 'granted') return
    var key = tag || 'gochat-message'
    // debounce ต่อ tag (ต่อลูกค้า) 2 วิ กันเด้งรัวเมื่อลูกค้าคนเดิมส่งข้อความติดกัน
    // ลูกค้าคนละคน (tag ต่างกัน) ยังเด้งแยกได้ตามปกติ
    var now = Date.now()
    if (!this._lastByTag) this._lastByTag = {}
    // prune entry เก่า (>60s) กัน map โตไม่จำกัดใน session ยาว (ร้าน volume สูง เปิดค้างข้ามวัน)
    for (var k in this._lastByTag) {
      if ((now - this._lastByTag[k]) > 60000) delete this._lastByTag[k]
    }
    if (this._lastByTag[key] && (now - this._lastByTag[key]) < 2000) return
    this._lastByTag[key] = now
    try {
      var n = new Notification(title, {
        body: body,
        tag: key,
        renotify: true,
      })
      n.onclick = function () {
        try { window.focus() } catch (e) {}
        try { n.close() } catch (e) {}
        if (typeof onClick === 'function') onClick()
      }
    } catch (e) {
      // สร้าง Notification ไม่สำเร็จ (เช่น OS block) — กลืน error ไม่ให้กระทบ message pipeline
    }
  }
}

// singleton — import ที่ไหนก็ instance เดียวกัน
export default new DesktopNotification()



// WEBPACK FOOTER //
// ./src/services/desktopNotification.js